<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header align-items-center d-flex">
                    <h4 class="card-title mb-0">{{this.$t('base.attribute')}}</h4>
                    <div v-if="attrList.length">
                        <b-button v-if="false" variant="primary" size="sm" class="ms-2 me-2" data-bs-toggle="dropdown"
                            data-bs-auto-close="inside" aria-haspopup="true"
                            aria-expanded="false">{{$t("base.create_qrcode")}}</b-button>
                        <div class="dropdown-menu dropdownmenu-info" aria-labelledby="dropdownMenuClickableOutside">
                            <div class="mb-2 ms-2" v-for="(item, i) in showQrcodelist" :key="i">
                                <input class="form-check-input me-1" type="checkbox" v-model="item.qrcodeChecked" />
                                <label class="form-check-label">{{ item.name }}</label>
                            </div>
                            <div class="text-end">
                                <b-button variant="outline-dark" size="sm" class="ms-2 me-2"
                                    @click="cancelQrcode()">{{$t("base.cancel")}}</b-button>
                                <b-button variant="primary" size="sm" class="ms-2 me-2"
                                    @click="saveQrcode()">{{$t('base.confirm')}}</b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body" v-if="attrList.length">
                    <div v-for="(item, I) in attrList" :key="I">
                        <div class="card-header align-items-center d-flex ps-0">
                            <h4 class="card-title mb-0 flex-grow-1">{{ $t(item.group) }}</h4>
                        </div>
                        <!-- 表头 -->
                        <div class="row table-head mt-2">
                            <div class="col-2">
                                <label class="form-label">{{this.$t('page.work-order.device.name')}}</label>
                            </div>
                            <div class="col-2">
                                <label class="form-label">{{this.$t('page.work-order.device.latest_value')}}</label>
                            </div>
                            <div class="col-2">
                                <label class="form-label"
                                    style="margin-left: 5rem">{{this.$t('page.work-order.device.unit')}}</label>
                            </div>
                            <div class="col-2">
                                <label class="form-label"
                                    style="margin-left: 5rem">{{this.$t('base.data_type')}}</label>
                            </div>
                        </div>
                        <!-- 表单内容 -->
                        <div class="table-content" v-if="item.list.length">
                            <div class="row table-content-row" v-for="(attr, i) in item.list" :key="i">
                                <!-- 名称value -->
                                <div v-if="attr.owner != 'self'" class="col-2 align-self-center">
                                    <span v-if="attr.required" class="must-input">* </span>
                                    {{ $t(attr.name) }}
                                </div>
                                <div v-else class="col-2 align-self-center">
                                    <input type="text" :class="['form-control']" maxlength="50"
                                        v-model.lazy="attr.name" />
                                </div>
                                <!-- 最新值value -->
                                <div class="col-2 el-box">
                                    <Multiselect v-if="
                      attr.name == '应用行业' ||
                      attr.name == '客户属性' ||
                      attr.name == '客户行业'
                    " :disabled="
                      attr.name == '客户属性' || attr.name == 'industry'
                    " v-model.lazy="attr.value" :close-on-select="true" :searchable="true" :canClear="true"
                                        :options="industryOptions(attr)" />
                                    <Multiselect v-else-if="attr.name == '设备状态'
                    " :disabled="attr.name == '客户属性' || attr.name == 'industry'
                    " v-model.lazy="attr.value" :close-on-select="true" :searchable="true" :canClear="true"
                                        :options="deviceStatus" />

                                    <el-select v-else-if="attr.name == '维保服务商'" v-model.lazy="attr.value"
                                        @change="maintenanceServiceProviderChange" @focus="serviceCompany" filterable
                                        clearable style="width: 100%; line-height: 37.5px" size="large"
                                        :placeholder="this.$t('page.tending.select_service_provider')">
                                        <el-option v-for="option in maintenanceServiceProvider" :label="option['label']"
                                            :value="option['value']" :key="option.value"></el-option>
                                    </el-select>
                                    <el-select v-else-if="attr.name == '客户名称'" v-model.lazy="attr.value"
                                        @focus="customerFocus" @change="clientChange"
                                        style="width: 100%; line-height: 37.5px" filterable size="large"
                                        :placeholder="this.$t('base.select_customer')" clearable>
                                        <el-option v-for="option in clientName" :label="option['label']"
                                            :value="option['value']" :key="option.value"></el-option>
                                    </el-select>
                                    <Multiselect v-else-if="attr.name == '设备联系人'" class="mb-3" v-model.lazy="attr.value"
                                        :close-on-select="true" :searchable="true" :canClear="true"
                                        :placeholder="$t('page.device-attr.Select_Down')" :options="attr.options || []"
                                        @change="deviceContactChange" @clear="deviceContactClear" />
                                    <Multiselect v-else-if="attr.name == '客户采购联系人'" class="mb-3"
                                        v-model.lazy="attr.value" :close-on-select="true" :searchable="true"
                                        :canClear="true" :placeholder="$t('page.device-attr.SelectUpperCustomer')"
                                        :options="attr.options || []" @change="customerContactChange"
                                        @clear="customerContactClear" />
                                    <el-date-picker v-else-if="I == 1 && attr.name == '发货时间'" v-model="attr.value"
                                        type="date" :class="[
                      'datapicker', 'w-100',
                      (isCheckForm && attr.required && !attr.value) && 'is-invalid',
                    ]" :format="altFormat" :value-format="altFormat" />
                                    <el-date-picker v-else-if="I == 1 && attr.name == '质保到期时间'" v-model="attr.value"
                                        type="date" class="datapicker w-100" :format="altFormat"
                                        :value-format="altFormat" />
                                    <input v-else type="text" :class="[
                      'form-control',
                      ((isCheckForm && attr.required && !attr.value) ||
                      (!attr.required && attr.value && attr.value.length > 50) ||
                      (attr.dataValidation && attr.dataValidation.type)) && 'is-invalid',
                    ]" @input="changeUpdate(attr)" v-model.lazy="attr.value" :disabled="
                      attr.name == '客户编码' ||
                      attr.name == '客户属性' ||
                      attr.name == '客户行业' ||
                      (I == 2 && attr.name == '所在位置') ||
                      attr.name == '客户地址' ||
                      attr.name == '客户电话' ||
                      attr.name == '客户邮箱' ||
                      attr.name == '客户官网' ||
                      attr.name == '客户采购联系人电话' ||
                      (attr.name == '设备联系电话' || attr.name == '设备联系人电话')
                    " />
                                    <div class="must-input position-absolute" v-show="
                    ((isCheckForm && attr.required && !attr.value) ||
                    (attr.value && attr.value.length > 50) ||
                    (attr.dataValidation && attr.dataValidation.type))
                    ">
                                        <span
                                            v-if="isCheckForm && attr.required && !attr.value">{{ requireError }}</span>
                                        <span v-else-if="attr.value && attr.value.length > 50">{{ error }}</span>
                                        <span v-else>{{ attr.dataValidation && attr.dataValidation.typeError }}</span>
                                    </div>
                                </div>
                                <!-- 单位 -->
                                <div v-if="attr.owner != 'self'" class="col-2 align-self-center"
                                    style="margin-left: 5rem">
                                    {{ attr.unit ? attr.unit : $t('page.no') }}
                                </div>
                                <div v-else class="col-2 align-self-center" style="margin-left: 5rem">
                                    <input type="text" :class="['form-control']" maxlength="50"
                                        v-model.lazy="attr.unit" />
                                </div>
                                <div class="col-2">
                                    <Multiselect :class="[
                      'form-control',
                      submitted && !attr.dtype && 'is-invalid',
                      attr.owner != 'self' && 'is-disabled',
                    ]" v-model.lazy="attr.dtype" :close-on-select="true" :searchable="false" :canClear="false"
                                        :options="dataTypes" :disabled="attr.owner != 'self'" />
                                </div>
                                <div v-if="attr.owner == 'self'" class="col-1 align-self-center"
                                    style="margin-left: 5rem">
                                    <b-button variant="primary" size="sm" :style="{
                      minWidth: '2.5rem',
                      marginTop: ' 0.34rem',
                      opacity: attr.disabled ? 0 : 1,
                    }" :disabled="attr.disabled" @click="tagMessageBox = i">{{this.$t('base.delete')}}</b-button>
                                    <MessageBox v-if="tagMessageBox == i" :messageCont="this.$t('page.deleteConfirm')"
                                        :messageIcon="'ri-error-warning-line'"
                                        :iconStyle="{ fontSize: '14px', color: '#f06548' }"
                                        :messageStyle="{ top: '-6rem', left: '-3.5rem' }" @makeSure="handleDelete(I, i)"
                                        @makeClose="tagMessageBox = null"></MessageBox>
                                </div>
                            </div>
                        </div>
                        <!-- 点击添加属性-->
                        <div class="addButton">
                            <b-button variant="primary" @click="addAttrData(I)">
                                {{this.$t('base.add_attribute')}}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css"; */
    import {
        ElDatePicker
    } from "element-plus";
    import "element-plus/theme-chalk/el-date-picker.css";
    import "element-plus/es/components/date-picker/style/css";
    import moment from "moment";
    import {
        equipStatus,
        equipDisciplineClass
    } from "@/utils/selectText.js";
    import Multiselect from "@vueform/multiselect";
    import MessageBox from "@/components/common/MessageBox.vue";

    import "@vueform/multiselect/themes/default.css";
    import "@/default.scss";
    import _ from "loadsh";
    import {
        v4 as uuidv4
    } from "uuid";
    import {
        dataTypes
    } from "@/utils/selectText.js";
    import {
        getCustomerOptions,
        customerDetail,
        getCustomerContacts
    } from "@/service";
    import {
        getCompany
    } from "@/helpers/common-service";

    export default {
        // directives: {
        //   // 这里实现一个组件内部的自定义指令
        //   loadmore: {
        //     // 指令的定义
        //     bind(el, binding) {
        //       const SELECTWRAP = el.querySelector(
        //         ".el-select-dropdown .el-select-dropdown__wrap"
        //       );
        //       if (!SELECTWRAP) {
        //         throw new Error('获取不到"el-select-dropdown__wrap"节点');
        //       }
        //       SELECTWRAP.addEventListener("scroll", () => {
        //         // scrollTop  这里可能因为浏览器缩放存在小数点的情况，导致了滚动到底部时
        //         // scrollHeight 减去滚动到底部时的scrollTop ，依然大于clientHeight 导致无法请求更多数据
        //         // 这里将scrollTop向上取整 保证滚到底部时，触发调用
        //         const CONDITION =
        //           SELECTWRAP.scrollHeight - Math.ceil(SELECTWRAP.scrollTop) <=
        //           SELECTWRAP.clientHeight;
        //         // el.scrollTop !== 0 当输入时，如果搜索结果很少，以至于没看到滚动条，那么此时的CONDITION计算结果是true，会执行bind.value()，此时不应该执行，否则搜索结果不匹配
        //         if (CONDITION && SELECTWRAP.scrollTop !== 0) {
        //           binding.value();
        //         }
        //       });
        //     },
        //   },
        // },
        data() {
            return {
                dataTypes: dataTypes,
                attrList: [],
                showQrcodelist: [],
                originQRcodelist: [],
                error: this.$t('page.character_length_cannot_exceed_50'),
                requireError: this.$t('base.required'),
                equipStatus: equipStatus,
                equipDisciplineClass: equipDisciplineClass,
                altFormat: "YYYY/MM/DD", //选择时显示的时间
                rangeDateconfig: {
                    wrap: true,
                    altFormat: "Y/m/d", //选择时显示的时间
                    altInput: true,
                    dateFormat: "Y/m/d",
                },
                tagMessageBox: null,
                maintenanceServiceProvider: [],
                clientName: [],
                clientList: [],
                customerContact: [],
                customer_id: this.customerid,
                service_company_id: "",
                keyword: "", // 存储关键字用
                loading: false,
                page: 1,
                customerChangeManually: false,
                deviceStatus: [{
                    label: this.$t('在用'),//"在用",
                    value: "在用"
                }, {
                    label: this.$t('备用'),//"备用",
                    value: "备用"
                }, {
                    label: this.$t('报废'),//"报废",
                    value: "报废"
                }],
            };
        },
        emits: ["update:attrDataList", "update:qrcodelist", "getCustomerid"],
        props: {
            isCheckForm: {
                type: Boolean,
                default: false,
            },
            attrDataList: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            qrcodelist: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            productType: {
                type: String,
                default: ""
            },
            customerid: {
                type: [String, Number],
                default: null
            }
        },
        setup() {

        },
        watch: {
            attrDataList: {
                handler(val) {
                    this.attrList = val;
                    this.dealAttrs()
                },
                deep: true,
                immediate: true,
            },
            attrList: {
                handler(val) {
                    this.$emit("update:attrDataList", val);
                },
                deep: true,
            },
            qrcodelist: {
                handler(val) {
                    this.originQRcodelist = val;
                    this.showQrcodelist = _.cloneDeep(val);
                },
                deep: true,
                immediate: true,
            },
            customerid: {
                handler(val) {
                    if (val && !this.customerChangeManually) {
                        this.customer_id = val
                        this.customerChange();
                    }
                },
                immediate: true,
            },
        },
        methods: {
            dealAttrs() {
                if (!this.attrList || !this.attrList.length) return
                // 没有序列号时将属性中的泵头序列号和机组序列号替换为序列号
                if (!_.some(this.attrList[0].list, ['name', '序列号'])) {
                    let snIndex = []
                    let snValue = ''
                    this.attrList[0].list.map((item, index) => {
                        if (item.name === '泵头序列号') {
                            if (this.productType == 1) {
                                snValue = item.value
                            }
                            snIndex.push(index)
                            item.name = '序列号'
                        }
                        if (item.name === '机组序列号') {
                            if (this.productType == 2) {
                                snValue = item.value
                            }
                            snIndex.push(index)
                            item.name = '序列号'
                        }
                    });
                    if (snIndex.length > 1) {
                        this.attrList[0].list.splice(snIndex[1], 1)
                    }
                    if (snValue) {
                        this.attrList[0].list[snIndex[0]].value = snValue
                    }
                }
                // 把所有unit为无或者None的替换为''
                this.attrList.map((group) => {
                    group.list.map(item => {
                        if (item.unit === '无' || item.unit === 'None') {
                            item.unit = ''
                        }
                    })
                })
            },
            customerFocus() {
                if (this.clientName && this.clientName.length > 0) return

                getCustomerOptions({
                        page_size: 0
                    })
                    .then((res) => {
                        this.clientName = [];
                        res.payload.map((a) => {
                            this.clientName.push({
                                label: a.name,
                                value: a.name,
                                key: a.id + "",
                            });
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            selectList(i) {
                return i == 4 ? this.equipStatus : this.equipDisciplineClass;
            },
            changeUpdate(obj) {
                this.attrList.map((item) => {
                    if (item.id == obj.id) {
                        item.updateTime = moment().format("YYYY-MM-DD HH:mm:ss");
                    }
                });
            },
            filterchuchangAttr(list) {
                this.Qrcodelist = _.find(list, ["group", this.$t(
                    'page.work-order.device.equipment_delivery_information')]).list || [];
                return this.Qrcodelist;
            },
            cancelQrcode() {
                this.showQrcodelist = _.cloneDeep(this.qrcodelist);
            },
            saveQrcode() {
                this.$emit("update:qrcodelist", this.showQrcodelist);
            },
            addAttrData(I) {
                this.tagMessageBox = null;

                let defaultData = {
                    owner: "self",
                    id: uuidv4(),
                    name: "",
                    default: "",
                    unit: "",
                    dtype: "string",
                    disabled: false,
                };
                this.attrList[I].list.push({
                    ...defaultData
                });
            },
            handleDelete(I, i) {
                if (this.attrList[I].list.length === 1) {
                    this.attrList.splice(I, 1);
                } else {
                    this.attrList[I].list.splice(i, 1);
                }
                this.tagMessageBox = null;
            },
            serviceCompany() {
                getCompany()
                    .then((res) => {
                        this.maintenanceServiceProvider = [];
                        res.map((a) => {
                            this.maintenanceServiceProvider.push({
                                label: a.name,
                                value: a.name,
                                key: a.id + "",
                            });
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            getValues() {
                if (!this.maintenanceServiceProvider || this.maintenanceServiceProvider.length === 0) {
                    getCompany()
                        .then((res) => {
                            this.maintenanceServiceProvider = [];
                            res.map((a) => {
                                this.maintenanceServiceProvider.push({
                                    label: a.name,
                                    value: a.name,
                                    key: a.id + "",
                                });
                            });
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
                if (!this.clientName || this.clientName.length === 0) {
                    getCustomerOptions({
                            page_size: 0
                        })
                        .then((res) => {
                            this.clientName = [];
                            res.payload.map((a) => {
                                this.clientName.push({
                                    label: a.name,
                                    value: a.name,
                                    key: a.id + "",
                                });
                            });
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            },
            deviceContactChange(e) {
                if (!e) return
                let options = []
                this.attrList[1].list.map((item) => {
                    if (item.name == '设备联系人') {
                        options = item.options
                    }
                });
                var tel = options.filter((item) => {
                    return item.value == e;
                })[0]["key"];
                this.attrList[1].list.map((item) => {
                    if (item.name == this.$t('page.device-attr.contact_number') || item.name == this.$t(
                            'page.device-attr.number')) {
                        item.value = tel;
                    }
                });
            },
            deviceContactClear() {
                this.attrList[1].list.map((item) => {
                    if (item.name == this.$t('page.device-attr.contact_number') || item.name == this.$t(
                            'page.device-attr.number')) {
                        item.value = "";
                    }
                });
            },
            customerContactChange(e) {
                if (!e) return
                let options = []
                this.attrList[2].list.map((item) => {
                    if (item.name == this.$t('page.device-attr.customer_purchasing_contact')) {
                        options = item.options
                    }
                });
                var tel = options.filter((item) => {
                    return item.value == e;
                })[0]["key"];
                this.attrList[2].list.map((item) => {
                    if (item.name == this.$t('page.device-attr.customer_purchasing_contact_number')) {
                        item.value = tel;
                    }
                });
            },
            customerContactClear() {
                this.attrList[2].list.map((item) => {
                    if (item.name == this.$t('page.device-attr.customer_purchasing_contact_number')) {
                        item.value = "";
                    }
                });
            },
            clientChange(e) {
                this.customerChangeManually = true
                this.customer_id = _.get(
                    this.clientName.filter((item) => {
                        return item.value == e;
                    }),
                    [0, "key"]
                );
                this.$emit("getCustomerid", {
                    customer_id: this.customer_id,
                });
                this.customerChange()
            },
            customerChange() {
                if (this.customer_id) {
                    if (this.customerChangeManually) {
                        customerDetail(this.customer_id)
                            .then((res) => {
                                this.attrList[2].list.map((item) => {
                                    if (item.name == '客户编码') {
                                        item.value = res.payload.code;
                                    } else if (item.name == '客户属性') {
                                        item.value = res.payload.attribute;
                                    } else if (item.name == '客户行业') {
                                        item.value = res.payload.industry;
                                    } else if (item.name == '所在位置') {
                                        item.value = (res.payload.country_txt || "") + (res.payload
                                            .province_txt || "") + (res.payload.city_txt || "");
                                    } else if (item.name == '客户地址') {
                                        item.value = res.payload.address;
                                    } else if (item.name == '客户电话') {
                                        item.value = res.payload.tel;
                                    } else if (item.name == '客户邮箱') {
                                        item.value = res.payload.email;
                                    } else if (item.name == '客户官网') {
                                        item.value = res.payload.home_url;
                                    } else if (item.name == '客户采购联系人') {
                                        item.value = "";
                                    } else if (item.name == '客户采购联系人电话') {
                                        item.value = "";
                                    } else if (item.name == '设备联系人') {
                                        item.value = "";
                                    } else if (item.name == '设备联系人电话' || item.name == '设备联系电话') {
                                        item.value = "";
                                    }
                                });
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                    }

                    getCustomerContacts({
                            customer: this.customer_id
                        })
                        .then((res) => {
                            // this.customerContact = [];
                            let options = []
                            res.payload.results.map((a) => {
                                options.push({
                                    label: a.name,
                                    value: a.name,
                                    key: a.tel + "",
                                    type: a
                                        .label // getCustomerContacts 默认返回 设备联系人 和 采购联系人，用label区分的
                                });
                            });
                            this.attrList[1] && this.attrList[1].list && this.attrList[1].list.map((item) => {
                                if (item.name == '设备联系人') {
                                    item.options = options.filter(_sub => _sub.type ===
                                        '设备联系人') // 过滤设备联系人数据
                                }
                            });
                            this.attrList[2].list.map((item) => {
                                if (item.name == '客户采购联系人') {
                                    item.options = options.filter(_sub => _sub.type ===
                                        '采购联系人') // 过滤采购联系人数据
                                }
                            });
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                } else {
                    this.attrList[1].list.map((item) => {
                        if (item.name == '设备联系人') {
                            item.options = []
                        }
                    });
                    this.attrList[2].list.map((item) => {
                        if (item.name == '客户采购联系人') {
                            item.options = []
                        }
                    });
                    this.attrList[2].list.map((item) => {
                        if (item.name == '客户编码') {
                            item.value = "";
                        } else if (item.name == '客户属性') {
                            item.value = "";
                        } else if (item.name == '客户行业') {
                            item.value = "";
                        } else if (item.name == '所在位置') {
                            item.value = "";
                        } else if (item.name == '客户地址') {
                            item.value = "";
                        } else if (item.name == '客户电话') {
                            item.value = "";
                        } else if (item.name == '客户邮箱') {
                            item.value = "";
                        } else if (item.name == '客户官网') {
                            item.value = "";
                        } else if (item.name == '客户采购联系人') {
                            item.value = "";
                        } else if (item.name == '客户采购联系人电话') {
                            item.value = "";
                        } else if (item.name == '设备联系人') {
                            item.value = "";
                        } else if (item.name == '设备联系人电话' || item.name == '设备联系电话') {
                            item.value = "";
                        }
                    });
                }
            },
            clientSearch(e) {
                console.log(e);
            },
            maintenanceServiceProviderChange(e) {
                this.service_company_id = _.get(
                    this.maintenanceServiceProvider.filter((item) => {
                        return item.value == e;
                    }),
                    [0, "key"]
                );
                this.$emit("getCustomerid", {
                    service_company_id: this.service_company_id,
                });
            },
            //应用行业Options翻译
            industryOptions(attr){
                let  reslut = []
                if(attr.name == '应用行业' && attr.options){
                    reslut = attr.options.map(item=>{
                        return { label: this.$t(`overview_dynamic.industy_dict['${item.label}']`),value:item.value}
                    })
                }else{
                    let list = _.cloneDeep(attr.options)
                    if(list) {
                        reslut = list.map(v => v.label = this.$t(v.label))
                    }
                }
                
                return reslut;
            }
        },
        mounted() {
            this.getValues();
            
        },
        components: {
            Multiselect,
            ElDatePicker,
            MessageBox,
            // flatPickr
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.datapicker .el-input__inner) {
        padding: 0 15px;
        height: 36px !important;
        border: 1px solid #ced4da00 !important;
        color: #212529 !important;

        &::placeholder {
            color: #7c7f8e;
            font-size: 0.8125rem;
        }

        &:focus {
            border-color: #b3c8f300 !important;
        }
    }

    :deep(.datapicker .el-input__wrapper) {
        &.is-focus {
            box-shadow: 0 0 0 1px #a0a8c4 inset !important;
            border-radius: 4px !important;
        }
    }

    :deep(.datapicker .el-input__prefix) {
        right: 5px;
        left: unset;
    }

    :deep(.datapicker .el-input__suffix) {
        right: 25px;
    }

    :deep(.datapicker.is-invalid>.el-input__wrapper) {
        border-color: #f06548 !important;
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f06548%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f06548%27 stroke=%27none%27/%3e%3c/svg%3e") !important;
        background-repeat: no-repeat !important;
        background-position: right calc(0.375em + 0.25rem) center !important;
        background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem) !important;
        box-shadow: 0 0 0 1px #f06548 inset !important;
    }
</style>